(function () {
  'use strict';

  /*
    Lichcards pre-order labels.

    21-09-2026 (snelheidsaudit, punt 2): de vorige versie herscande bij élke
    DOM-mutatie de hele pagina en maakte per element een nieuwe
    Intl.DateTimeFormat. Op collectiepagina's met 48 kaarten kostte dat
    2,7 s CPU. Nu: datumsleutel gecached, alleen de gewijzigde elementen
    worden gesynchroniseerd, en de observer negeert mutaties buiten
    pre-order-elementen. Gedrag (labels, hidden/disabled) is ongewijzigd.
  */

  var ATTR = 'data-preorder-release';
  var SELECTOR = '[' + ATTR + ']';
  var cachedKey = null;
  var cachedAt = 0;
  var scheduled = false;
  var pending = [];

  function computeAmsterdamDateKey() {
    try {
      var parts = new Intl.DateTimeFormat('en', {
        timeZone: 'Europe/Amsterdam',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());
      var values = {};
      parts.forEach(function (part) { values[part.type] = part.value; });
      return values.year + '-' + values.month + '-' + values.day;
    } catch (error) {
      var now = new Date();
      var year = now.getFullYear();
      var month = String(now.getMonth() + 1).padStart(2, '0');
      var day = String(now.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    }
  }

  function amsterdamDateKey() {
    var now = Date.now();
    if (!cachedKey || now - cachedAt > 60000) {
      cachedKey = computeAmsterdamDateKey();
      cachedAt = now;
    }
    return cachedKey;
  }

  function isActive(releaseDate) {
    return /^\d{4}-\d{2}-\d{2}$/.test(releaseDate || '') && releaseDate > amsterdamDateKey();
  }

  function syncElement(element) {
    var releaseDate = element.getAttribute('data-preorder-release');
    var active = isActive(releaseDate);
    var role = element.getAttribute('data-preorder-role');

    if (role === 'notice' || role === 'cart-badge') {
      if (element.hidden !== !active) element.hidden = !active;
      return;
    }
    if (role === 'line-property') {
      if (element.disabled !== !active) element.disabled = !active;
      return;
    }
    if (role === 'accelerated') {
      var canAdd = element.getAttribute('data-preorder-can-add') === 'true';
      var hide = active || !canAdd;
      if (element.hidden !== hide) element.hidden = hide;
      return;
    }
    if (role === 'button') {
      var target = element.querySelector('[data-preorder-label-target]') ||
        element.querySelector('.add-to-cart-text__content') ||
        element.querySelector('.add-to-cart-text');
      if (!target) return;

      var preorderLabel = element.getAttribute('data-preorder-label');
      var normalLabel = element.getAttribute('data-preorder-normal-label');
      if (!preorderLabel || !normalLabel) return;

      if (active && !element.disabled && !element.classList.contains('sold-out--button')) {
        if (target.textContent.trim() !== preorderLabel) target.textContent = preorderLabel;
        if (element.getAttribute('data-preorder-active') !== 'true') element.setAttribute('data-preorder-active', 'true');
      } else {
        if (!active && target.textContent.trim() === preorderLabel) target.textContent = normalLabel;
        if (element.hasAttribute('data-preorder-active')) element.removeAttribute('data-preorder-active');
      }
    }
  }

  function sync(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches(SELECTOR)) syncElement(scope);
    var list = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) syncElement(list[i]);
  }

  function flush() {
    scheduled = false;
    var items = pending;
    pending = [];
    if (items.indexOf(document) !== -1) {
      sync(document);
      return;
    }
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (el.isConnected === false) continue;
      sync(el);
    }
  }

  function queue(el) {
    if (pending.indexOf(el) === -1) pending.push(el);
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(flush);
  }

  function scheduleSync() {
    queue(document);
  }

  function onMutations(records) {
    for (var i = 0; i < records.length; i++) {
      var record = records[i];
      var target = record.target;
      if (record.type === 'attributes') {
        // Alleen wijzigingen (disabled/class/hidden) op een pre-order-element
        // zelf zijn relevant, bv. de koopknop die uitverkocht wordt.
        if (target && target.nodeType === 1 && target.hasAttribute(ATTR)) queue(target);
        continue;
      }
      if (record.type !== 'childList') continue;

      // Tekst binnen een pre-order-element vervangen (thema schrijft de
      // knoptekst opnieuw bij een variantwissel) → dat element opnieuw doen.
      var host = target && target.nodeType === 1 ? target.closest(SELECTOR) : null;
      if (host) {
        queue(host);
        continue;
      }
      // Nieuw ingevoegde blokken (quick view, cart drawer, "Toon meer") die
      // pre-order-elementen bevatten → alleen dat blok scannen.
      var added = record.addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.hasAttribute(ATTR) || node.querySelector(SELECTOR)) queue(node);
      }
    }
  }

  function start() {
    sync(document);
    var observer = new MutationObserver(onMutations);
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled', 'class', 'hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('submit', function (event) { sync(event.target); }, true);
  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('shopify:section:reorder', scheduleSync);
  document.addEventListener('product:variant-change', scheduleSync);
  document.addEventListener('variant:change', scheduleSync);
})();
